import { useState, useEffect} from 'react'
import { BrowserRouter, Routes,Route, redirect  } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/custom.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import './App.css'
import { ToastContainer } from 'react-toastify';
import UploadcsvPage from './pages/UploadcsvPage';
import AuditorPage from './pages/AudiorPage';
import OverviewPage from './pages/OverviewPage';
import ExternalRedirect from './pages/mfasetup/ExternalRedirect';
import MFADashboardPage from './pages/mfasetup/MfaDashboardPage';

function App() {

  const [status, setStatus] = useState(true);
  
 // const access_token =()=>{ 
 //   const sesstionaccess = sessionStorage.getItem('access_token');
   //   if(sesstionaccess){
     //   setStatus(true);
     // }else{
      //  setStatus(false);
     // }
//}

  useEffect(() => {
    const user = sessionStorage.getItem("user")
    if(!user){
      setStatus(false);
    }
    else{
      setStatus(true);
    }

    
  //access_token()
    // getSession()
    //   .then(session => {
    //    // console.log('Session:', session);
    //     const groupname =session.accessToken.payload['cognito:groups'].toString()
    //    // console.log(groupname)
    //     sessionStorage.setItem('group', groupname)
    //     // Store tokens securely (e.g., in state or localStorage)

    //     const accessToken = session.getAccessToken().getJwtToken();
    //     const idToken = session.getIdToken().getJwtToken();
    //     const refreshToken = session.getRefreshToken().getToken();
    //     localStorage.setItem('accessToken', accessToken);
    //     localStorage.setItem('idToken', idToken);
    //     localStorage.setItem('refreshToken', refreshToken);
    //     setStatus(true);
      
    //   }, err => console.log(err))
      }, []);

  //const usersess = localStorage.getItem('CognitoIdentityServiceProvider.253ou090n4acnedorimg03ir33.LastAuthUser');

  return (
 <>
 <ToastContainer position="bottom-right" pauseOnHover={false}/>
 {/* <Account> */}
      <BrowserRouter basename='/'>
      <Routes>
        <Route path ='/'           element={<ExternalRedirect/>}/>
        <Route path ='/dashboard'  element={ <MFADashboardPage/>} />
        <Route path ='/uploadcsv'  element={status ?<UploadcsvPage/>: <ExternalRedirect/> } />
        <Route path ='/audit'      element={status ? <AuditorPage/> : <ExternalRedirect/> } />
        <Route path='/report'  element={status ? <OverviewPage/>: <ExternalRedirect/>}/>

      </Routes>
      </BrowserRouter>
  {/* </Account> */}
</>
  )
}
export default App
